import { lazy } from 'react';

// export const ContraVoucherLazy = lazy(
//   () => import('@/pages/vouchers/ContraVoucher'),
// );
// export const ContraVoucherListLazy = lazy(
//   () => import('@/pages/vouchers/ContraVoucherList'),
// );
export const ContraVoucherListLazy = lazy(
  () => import('@/pages/vouchers/contra/ContraVoucherList'),
);
export const ContraVoucherCreateLazy = lazy(
  () => import('@/pages/vouchers/contra/create/ContraVoucherCreate'),
);
export const ContraVoucherEditLazy = lazy(
  () => import('@/pages/vouchers/contra/edit/ContraVoucherEdit'),
);

// export const JornalVoucherLazy = lazy(
//   () => import('@/pages/vouchers/JornalVoucher'),
// );
// export const JornalVoucherListLazy = lazy(
//   () => import('@/pages/vouchers/JornalVoucherList'),
// );
export const JornalVoucherListLazy = lazy(
  () => import('@/pages/vouchers/journal/JournalVoucherList'),
);
export const JornalVoucherCreateLazy = lazy(
  () => import('@/pages/vouchers/journal/create/JournalVoucherCreate'),
);
export const JornalVoucherEditLazy = lazy(
  () => import('@/pages/vouchers/journal/edit/JournalVoucherEdit'),
);

export const MetalToCashLazy = lazy(
  () => import('@/pages/vouchers/MetalToCash'),
);
export const MetalToCashListLazy = lazy(
  () => import('@/pages/vouchers/MetalToCashList'),
);

// export const PaymentVoucherLazy = lazy(
//   () => import('@/pages/vouchers/Payment'),
// );
// export const PaymentVoucherListLazy = lazy(
//   () => import('@/pages/vouchers/PaymentVoucherList'),
// );
export const PaymentVoucherCreateLazy = lazy(
  () => import('@/pages/vouchers/payment/create/PaymentVoucherCreate'),
);
export const PaymentVoucherEditLazy = lazy(
  () => import('@/pages/vouchers/payment/edit/PaymentVoucherEdit'),
);
export const PaymentVoucherListLazy = lazy(
  () => import('@/pages/vouchers/payment/PaymentVoucherList'),
);

// export const ReceiptVoucherLazy = lazy(
//   () => import('@/pages/vouchers/ReceiptVoucher'),
// );
// export const ReceiptVoucherListLazy = lazy(
//   () => import('@/pages/vouchers/ReceiptVoucherList'),
// );
export const ReceiptVoucherListLazy = lazy(
  () => import('@/pages/vouchers/receipt/ReceiptVoucherList'),
);
export const ReceiptVoucherCreateLazy = lazy(
  () => import('@/pages/vouchers/receipt/create/ReceiptVoucherCreate'),
);
export const ReceiptVoucherEditLazy = lazy(
  () => import('@/pages/vouchers/receipt/edit/ReceiptVoucherEdit'),
);

export const DisableFirstTableLazy = lazy(
  () => import('@/tables/DisableFirstTable'),
);

export const CashToMetalListLazy = lazy(
  () => import('@/pages/vouchers/CashToMetalList'),
);

export const CashToMetalLazy = lazy(
  () => import('@/pages/vouchers/CashToMetal'),
);

export const MetalTransferListLazy = lazy(
  () => import('@/pages/vouchers/MetalTransfer/MetalTransferList'),
);
export const MetalTransferCreateLazy = lazy(
  () => import('@/pages/vouchers/MetalTransfer/create/MetalTransferCreate'),
);
export const MetalTransferEditLazy = lazy(
  () => import('@/pages/vouchers/MetalTransfer/edit/MetalTransferEdit'),
);

export const IssueKarigarCreateLazy = lazy(
  () => import('@/components/pages/issue/IssueKarigarCreate'),
);
export const IssueKarigarListLazy = lazy(
  () => import('@/components/pages/issue/IssueKarigarList'),
);

export const IssuePartyCreateLazy = lazy(
  () => import('@/components/pages/issue/IssuePartyCreate'),
);
export const IssuePartyListLazy = lazy(
  () => import('@/components/pages/issue/IssuePartyList'),
);

export const IssueRefineCreateLazy = lazy(
  () => import('@/components/pages/issue/IssueRefineCreate'),
);
export const IssueRefineListLazy = lazy(
  () => import('@/components/pages/issue/IssueRefineList'),
);

export const StockLazy = lazy(
  () => import('@/components/pages/transaction/stock/Stock'),
);
export const StockListLazy = lazy(
  () => import('@/components/pages/transaction/stock/StockList'),
);
